import { OutlinedInput, OutlinedInputProps } from "@mui/material";
import { fieldRootSx, FIELD_HEIGHT } from "./fieldStyles";

const MULTILINE_PADDING = "8px 11px";

export type InputFieldProps = Omit<OutlinedInputProps, "size" | "color">;

/**
 * Common text input (MUI). Same look as "Category name" in category AddModal.
 * Works as an antd `Form.Item` child (receives value/onChange/aria-invalid).
 */
const InputField = ({ sx, multiline, fullWidth = true, ...rest }: InputFieldProps) => {
  const invalid = rest["aria-invalid"] === true || rest["aria-invalid"] === "true";
  return (
    <OutlinedInput
      fullWidth={fullWidth}
      multiline={multiline}
      error={rest.error ?? invalid}
      sx={[
        fieldRootSx,
        multiline && {
          height: "auto",
          minHeight: FIELD_HEIGHT,
          "& .MuiOutlinedInput-input": { padding: MULTILINE_PADDING },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    />
  );
};

export default InputField;
